import React from 'react';

function About() {
  return (
    <div className="page-content">
      <div className="page-header">
        <h1>About Sol LLP</h1>
        <p>Dedicated to excellence in legal representation since 2008</p>
      </div>

      <section className="content-section">
        <div className="text-content">
          <p>Sol LLP is a leading law firm in Kelowna, British Columbia, specializing in family law and personal injury matters. Founded in 2008, our firm has built a reputation for providing compassionate, effective, and results-driven legal services to individuals and families throughout the Okanagan Valley.</p>

          <h3>Our Philosophy</h3>
          <p>We believe that every client deserves personalized attention and aggressive advocacy. Legal matters affecting your family or your health are among the most important challenges you'll face, and we treat them with the seriousness and dedication they deserve.</p>

          <h3>Our Approach</h3>
          <p>At Sol LLP, we combine deep legal knowledge with practical problem-solving. We take the time to understand your unique situation, explain your options clearly, and develop strategies tailored to your goals. Whether through negotiation, mediation, or litigation, we fight tirelessly to protect your rights and interests.</p>

          <h3>Community Commitment</h3>
          <p>As long-time members of the Kelowna community, we're proud to give back through pro bono work, sponsorship of local initiatives, and active participation in the Law Society of British Columbia. We're not just your lawyers—we're your neighbors.</p>

          <h3>Professional Recognition</h3>
          <p>Our attorneys have been recognized by:</p>
          <ul>
            <li>Best Lawyers in Canada</li>
            <li>Canadian Bar Association</li>
            <li>Trial Lawyers Association of British Columbia</li>
            <li>Kelowna Chamber of Commerce</li>
          </ul>

          <h3>Why We're Different</h3>
          <p>Unlike larger firms where you're just a file number, at Sol LLP you'll work directly with experienced lawyers who genuinely care about your outcome. We limit our caseload to ensure every client receives the attention they deserve. Our boutique approach means responsive communication, strategic thinking, and a personal investment in your success.</p>
        </div>
      </section>
    </div>
  );
}

export default About;

